import {BaseModel} from "./BaseModel";
import angular from "angular";


export class ExtraDataModel extends BaseModel {

     /**
     * @param {object} initializer - {
     *          spouse_first_name               string    optional            Spouse first name
     *          spouse_last_name                string    optional            Spouse last name
     *          spouse_birth_date               string    optional            Spouse birth date
     *          permission_to_call              boolean   optional            Permission to call
     *          permission_to_leave_message     boolean   optional            Permission to leave message
     *          best_time_to_call               string    optional            Best time to call
     *          language                        string    optional            Language
     *          how_did_you_hear                string    optional            Hod did you hear us
     *          policy_holder                   boolean   optional            Policy holder
     *          policy_number                   string    optional/required   Policy number
     *          csr_initials                    string    optional            Customer Service Rep (CSR) initials
     *          cost_to_agent                   boolean   optional            Cost to Agent
     *          comments                        string    optional            Comments
     *          spouse_policy_number            string    optional/required   Spouse/Household Policy Number
     * }
     */
    constructor(initializer) {
        let init = (initializer) ? angular.copy(initializer) : {};
        let required =  [];
        super(required, init);
    }

    serialize() {
        let serialized = super.serialize();
        if (serialized.spouse_birth_date) {
            serialized.spouse_birth_date = this.serializeDropdownDate(serialized.spouse_birth_date);
            let today = new Date();
            let birthDate = new Date(serialized.spouse_birth_date);
            let age = today.getFullYear() - birthDate.getFullYear();
            let m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            serialized.spouse_age = age;
        }
        return serialized;
    }
}

export class ExtraDataService {

    constructor() { }

    newModel(initializer) {
        return new ExtraDataModel(initializer);
    }
}



// WEBPACK FOOTER //
// ./app/jangl/ExtraDataService.js